/*
 * ******************************************************************
 * Copyright (c) 2023-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from "@angular/core";

// @formatter:off
@Component({
    standalone: false,
    selector: "radio-card",
    templateUrl: "./radio-card.component.html",
    styleUrls: ["./radio-card.component.scss"],
    host: {'class': 'clr-radio-wrapper'}
})
// @formatter:on
export class RadioCardComponent {

    @Input()
    public value: any;

    @Input()
    public id: string;

    @Input()
    public name: string;

    @Input()
    public label: string;

    @Input()
    public icon: string;

    @Input()
    public iconSize: string = "xl";

    @Input()
    public description: string;

    @Input()
    public model: any;

    @Output()
    public modelChange: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    public radioChecked: EventEmitter<void> = new EventEmitter<void>();

    constructor() {
    }

    // class bindings
    @HostBinding("class") classes: string = "clr-radio-wrapper";

    @HostBinding("class.selected") get selected(): boolean {
        return this.model === this.value;
    }

    @HostListener("click", ["$event"])
    @HostListener("keyup.space", ["$event"])
    @HostListener("keyup.enter", ["$event"])
    onRadioChecked(_e: any): void {
        if (this.model === this.value) {
            return;
        }
        this.model = this.value;
        this.modelChange.emit(this.model);
        this.radioChecked.emit(this.value);
    }
}
